import axiosInstance from "./apiinterseptor";
export interface ICreateCandidateRequestBody {

  name: string;
  email: string;
  phone: string;
  fatherName: string;
  dateOfBirth: string; // Expecting an ISO 8601 date string, e.g., "1995-08-22"
  gender: 'Male' | 'Female' | 'Other';
  aadharNumber?: string; // Note: Ensure secure handling of this sensitive data
  highestQualification: string;
  currentLocationDetails: ICandidateAddress; // The full address object
  spokenLanguages: string[];
  profileSource?: string;
  totalExperienceYears: number;
  totalExperienceMonths: number;
  skills: string[];
  preferredJobCategories: string[];
  preferredEmploymentTypes: string[];
  preferredWorkTypes: ('remote' | 'hybrid' | 'on-site')[];
}

export interface ICandidateAddress {
  street?: string;
  area?: string;
  city?: string;
  pincode?: string;
  fullAddress?: string;
}
export const updateTalentPoolApplications = async (
  id: string,
  status: "shortlisted" | "rejected",
  jobId?: string 
) => {
  try {
    const payload = { id, status, jobId };
    console.log(payload)
    const response = await axiosInstance.patch(`/talentPoolCandidates/status`, payload);

    return response.data; // return data so caller can use it
  } catch (error) {
    console.error("Failed to update talent pool application:", error);
    throw error; // rethrow if you want to handle it outside
  }
};


export const bulkUploadTalentPoolCandidates = async (candidates: ICreateCandidateRequestBody[]) => {
  try {
    const response = await axiosInstance.post('/talentPoolCandidates/bulkUpload', candidates);
    return response.data;
  } catch (error) {
    console.error("Failed to bulk upload talent pool candidates:", error);
    throw error;
  }
};